export { default, type DetailsFormRef } from './DetailsForm'
